var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['ui-action-button', _vm.variantClass, _vm.pillClass, { disabled: _vm.disabled }],style:(_vm.sizeStyle),attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }